<template>
  <transition-group tag="div" name="fade" class="row" appear>
    <slot></slot>
  </transition-group>
</template>

<script>
export default {
  name: "CheckoutPaymentsWrapper",
};
</script>
